module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "wrap-password px-0 py-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 150px)"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "passCheck",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitPass($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "passCheck"
    }
  }, [_vm._v("Mã tra cứu")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('v-btn', {
    staticClass: "kios-btn",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingTable,
      "disabled": _vm.loadingTable
    },
    on: {
      "click": _vm.submitPass
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "20"
    }
  }, [_vm._v("search")]), _vm._v("\n           \n          Tra Cứu\n          "), _c('span', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_vm._v("Loading...")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center text-bold mt-3",
    staticStyle: {
      "color": "#065694"
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Mã tra cứu là dãy số gồm 4 ký tự được in trên")]), _vm._v(" "), _c('p', {
    staticClass: "mb-1"
  }, [_vm._v(" GIẤY TIẾP NHẬN HỒ SƠ VÀ HẸN TRẢ KẾT QUẢ")])])]), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n        "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.dossierNo))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5770123c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5770123c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckPassword.vue
// module id = 529
// module chunks = 1